import { StatusFormatterVariant } from '@components'

import { InvoiceStatus } from '@features/invoicesLegacy/enums/invoiceStatus'

export const invoiceStatusToStatusFormatterVariant: Record<
  InvoiceStatus,
  StatusFormatterVariant | [StatusFormatterVariant, StatusFormatterVariant]
> = {
  [InvoiceStatus.All]: 'neutral',
  [InvoiceStatus.Credited]: 'success',
  [InvoiceStatus.Draft]: 'primary',
  [InvoiceStatus.Overdue]: 'error',
  [InvoiceStatus.Paid]: 'success',
  [InvoiceStatus.PartiallyCredited]: ['success', 'warning'],
  [InvoiceStatus.PartiallyPaid]: ['success', 'warning'],
  [InvoiceStatus.Unpaid]: 'warning',
}
